<template>
  <listing-layout :style="{ '--apperances-color': computedColor }" no-sm-padding>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="nominate__title h2 mb-3">{{ event && event.name ? event.name : '' }}</h1>
    </div>
    <div slot="content" class="leaders">
      <div class="alert alert-warning" v-if="error">{{ error }}</div>

      <statistics v-if="statistics" :statistics="statistics" :appearances="appearances" />

      <!-- Round tabs -->
      <div v-if="event && event.rounds && event.rounds.length" class="leaders__tabs leaders__tabs_small m-0" :style="{ '--apperances-color': computedColor }">
        <router-link
          v-for="(round, i) in event.rounds"
          :key="i"
          :to="{
            name: 'LeadersEventCutoutHighest',
            params: { event_id: $route.params.event_id, round: round.round }
          }"
          :class="['leaders__tab', 'leaders__tab_round', isRoundActive(round) ? 'active' : '']"
        >
          {{ roundLabel(round) }}
        </router-link>
      </div>

      <div v-if="entity.event_id" class="leaders-event _single">
        <div class="leaders-event__body active" style="margin-top: 24px;">
          <ul class="leaders-event__main-row">
            <li class="col-1 tac">Run</li>
            <li class="col-6 col-mob-9 display-md">Info</li>
            <li class="col-3 hidden-md">Rider name</li>
            <li class="col-3 hidden-md">Horse name</li>
            <li class="col-2 tac hidden-md">Round</li>
            <li class="col-2 hidden-sm tac">Cutout</li>
          </ul>

          <div class="js-event-infinite">
            <div v-if="loading && !draws.length" class="text-center py-3">
              Loading...
            </div>

            <ul v-for="(draw, idx) in draws" :key="draw.id">
              <li class="col-1 tac">{{ idx + 1 }}</li>
              <li class="col-6 col-mob-9 display-md">
                <div><span>Rider name:</span> <link-rider :draw="draw" /></div>
                <div><span>Horse name:</span> {{ draw.horse_name }}</div>
                <div v-if="selectedRound > 0"><span>Round:</span> {{ selectedRound + 1 }}</div>
                <div class="display-sm"><span>Cutout: </span>{{ draw.cutout }}</div>
              </li>
              <li class="col-3 hidden-md"><link-rider :draw="draw" /></li>
              <li class="col-3 hidden-md">{{ draw.horse_name }}</li>
              <li class="col-2 tac hidden-md">{{ selectedRound + 1 }}</li>
              <li class="col-2 hidden-sm tac">{{ draw.cutout !== null && draw.cutout !== undefined ? draw.cutout : '-' }}</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import getAppearances from '../Listing/mixins/getAppearances'
import getStatistics from '../Listing/mixins/getStatistics'
import Statistics from '../Listing/components/Statistics'
import fetchData from '../../../mixins/apiHelpers'
import LinkRider from '../Listing/components/Links/LinkRider'

export default {
  name: 'LeadersEventCutoutHighest',
  mixins: [getAppearances, getStatistics],
  computed: {
    entity() {
      return {
        model: 'event',
        id: this.event ? this.event.draft_id : null,
        event_id: this.$route.params.event_id
      }
    },
    computedColor() {
      return this.appearances && this.appearances.schema_color
        ? `${this.appearances.schema_color}`
        : 'var(--primary)'
    },
    selectedRound() {
      return Number(this.$route.params.round) || 0
    }
  },
  watch: {
    '$route.params': {
      immediate: true,
      handler() {
        this.fetchEventData()
      }
    }
  },
  components: {
    'listing-layout': listingLayout,
    Statistics,
    'link-rider': LinkRider
  },
  data() {
    return {
      event: null,
      draws: [],
      error: null,
      loading: false
    }
  },
  provide() {
    const self = this
    return {
      get entity() {
        return {
          model: 'event',
          id: self.event ? self.event.draft_id : null,
          event_id: self.$route.params.event_id
        }
      }
    }
  },
  methods: {
    isRoundActive(round) {
      return round.round === this.selectedRound
    },
    roundLabel(round) {
      if (round.name === 'Final') return 'Final'
      if (round.name && round.name.toLowerCase().includes('run-off')) return round.name.toUpperCase()
      return round.name
    },
    async fetchEventData() {
      this.loading = true
      this.draws = []

      const round = this.$route.params.round || 0
      const url = `${this.$api}/leaders/events/${this.$route.params.event_id}/cutout-highest/${round}`

      await fetchData(url, (response) => {
        const newEvent = response.data.data.event

        // rounds list comes from round=0, preserve it when switching rounds
        if (newEvent.rounds && newEvent.rounds.length) {
          this.event = newEvent
        } else if (this.event) {
          this.event = { ...newEvent, rounds: this.event.rounds }
        } else {
          this.event = newEvent
        }

        this.draws = response.data.data.draws || []

        if (!this.statistics) {
          this.fetchStatistics()
        }

        if (this.event && this.event.draft_id) {
          this.$root.$emit('update-breadcrumb', {
            name: 'Draft',
            link: `leaders/drafts/${this.event.draft_id}`
          })
          this.$root.$emit('update-breadcrumb', {
            name: 'Event',
            link: `leaders/events/${this.$route.params.event_id}/${this.selectedRound}`
          })
        }
      }, this)

      this.loading = false
    }
  }
}
</script>

<style scoped>
  .leaders a {
    color: var(--apperances-color) !important;
  }

  .nominate__title {
    color: var(--apperances-color) !important;
  }

  .leaders__tabs {
    border-color: var(--apperances-color) !important;
  }

  .leaders__tab {
    color: var(--apperances-color) !important;
    border-left-color: var(--apperances-color) !important;
  }

  .leaders .leaders__tab.active {
    background-color: var(--apperances-color) !important;
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Leaders/CutoutHighest/Event.vue